import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import { ConsumptionNomenclatureDetail } from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getConsumptionNomenclatureDetail: builder.query<ConsumptionNomenclatureDetail, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ConsumptionNomenclature/${data.id}`,
      }),
    }),
    changeConsumptionNomenclature: builder.mutation<void, ConsumptionNomenclatureDetail>({
      query: (data) => ({
        url: `/v1/ConsumptionNomenclature/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createConsumptionNomenclature: builder.mutation<void, ConsumptionNomenclatureDetail>({
      query: (data) => ({
        url: '/v1/ConsumptionNomenclature',
        method: 'POST',
        body: data,
      }),
    }),
    deleteConsumptionNomenclature: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ConsumptionNomenclature/${data.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useChangeConsumptionNomenclatureMutation,
  useCreateConsumptionNomenclatureMutation,
  useDeleteConsumptionNomenclatureMutation,
  useGetConsumptionNomenclatureDetailQuery,
  useLazyGetConsumptionNomenclatureDetailQuery,
} = request;
